import {ACTION_TYPES} from 'Utils/constants';

/**
 * Sets the selected level code in Map Editor, DSM, Parking Manager, Explorer and Digital Signs including Kiosk
 * @todo support this in Kiosk
 *
 * @param {?string} levelCode
 */
const setSelectedLevelCode = levelCode => ({
    type: ACTION_TYPES.SET_SELECTED_LEVEL_CODE,
    data: levelCode,
});

export default setSelectedLevelCode;
